// *****************************************
// ************* Image Gallery *************
// *****************************************

import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import './thumbnail-gallery.scss';

class ProductGallery {

    constructor(el) {
        this.el = el;
        this.collectionsItem = el.classList.contains('collections-thumbnail-gallery');
        this.imageSizesOkay = true;
        this.lightbox = null;
        this.activeIndex = 0;
        this.main = el.querySelector('.thumbnail-gallery--main-image');
        this.mainImg = el.querySelector('.thumbnail-gallery--main-image figure img');
        this.mainImgFigCaption = el.querySelector('.thumbnail-gallery--main-image figure figcaption');
        this.items = [];
        let findItems = el.querySelectorAll('ul li a');
        this.loop = findItems.length > 1;
        if(findItems != null) {
            [...findItems].forEach((itemElement, itemIndex) => {
                let dataWidth = itemElement.dataset.pswpWidth,
                    dataHeight = itemElement.dataset.pswpHeight;
                this.items[itemIndex] = {
                    el: itemElement,
                    src: itemElement.getAttribute('href'),
                    width: parseFloat(dataWidth) > 0 ? parseFloat(dataWidth) : 0,
                    height: parseFloat(dataHeight) > 0 ? parseFloat(dataHeight) : 0,
                    img: itemElement.querySelector('img'),
                    alt: itemElement.querySelector('figcaption').innerText,
                    figCaptionHTML: itemElement.querySelector('figcaption').innerHTML,
                };
                this.imageSizesOkay = this.items[itemIndex].width > 0 && this.items[itemIndex].height > 0;
            });
        }
        // open gallery with 'main' button
        this.main.onclick = (e) => {
            e.stopPropagation();
            e.preventDefault();
            if(!this.imageSizesOkay) {
                this.getImageDimensions(this.activeIndex);
            } else {
                this.createLightbox(this.activeIndex);
            }
        };
        // thumbnail links load image into 'main' area and change the activeIndex
        for(var x=0; x < this.items.length; x++) {
            let index = x,
                _this = this;
            this.items[x].el.onclick = (e) => {
                e.stopPropagation();
                e.preventDefault();
                _this.setActiveThumbnail(index);
            };
        }
        this.items[this.activeIndex].el.classList.add('active');
    }

    getImageDimensions(priorityIndex) {
        // priority index
        if(this.items[priorityIndex].width == 0 || this.items[priorityIndex].height == 0) {
            let index = priorityIndex;
            this.items[priorityIndex].image = new Image();
            this.items[priorityIndex].image.onload = () => {
                this.imageLoaded(priorityIndex, true);
            }
            this.items[priorityIndex].image.src = this.items[priorityIndex].src;
        } else {
            this.createLightbox(priorityIndex);
        }
        // other images
        for(var x=0; x < this.items.length; x++) {
            if( x !== priorityIndex) {
                if(this.items[x].width == 0 || this.items[x].height == 0) {
                    let index = x;
                    this.items[x].image = new Image();
                    this.items[x].image.onload = () => {
                        this.imageLoaded(index, false);
                    }
                    this.items[x].image.src = this.items[x].src;
                }
            }
        };
    }

    imageLoaded(i, create) {
        let w = this.items[i].image.width,
            h = this.items[i].image.height;
        this.items[i].width = w;
        this.items[i].height = h;
        if(create) {
            this.createLightbox();
        } else {
            this.lightbox.options.dataSource[i].width = w;
            this.lightbox.options.dataSource[i].height = h;
            this.lightbox.refreshSlideContent(i);
        }
    }

    createLightbox() {
        this.lightbox = new PhotoSwipe({
            dataSource: this.items,
            loop: this.loop,
            index: this.activeIndex
        });
        // update thumbnails on slide change
        this.lightbox.on('change', () => {
            // triggers when slide is switched, and at initialization
            this.setActiveThumbnail(this.lightbox.currSlide.index);
        });
        // init
        this.lightbox.init();
    }

    setActiveThumbnail(index) {
        this.items[this.activeIndex].el.classList.remove('active');
        this.items[index].el.classList.add('active');
        if(this.collectionsItem) {
            this.mainImg.removeAttribute('srcset');
            this.mainImg.setAttribute('src', this.items[index].src);
        } else {
            this.mainImg.setAttribute('src', this.items[index].img.dataset.src);
            this.mainImg.setAttribute('srcset', this.items[index].img.dataset.srcset);
        }
        this.mainImg.setAttribute('alt', this.items[index].alt);
        this.mainImgFigCaption.innerHTML = this.items[index].figCaptionHTML;
        this.activeIndex = index;
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ProductGallery(node);
        }
    });
}